import React from 'react';
import { Link } from 'react-router-dom';
import categories from '../functions/Categories.json';

function Footer() {
  // Function to scroll to top when a link is clicked
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // Get first 6 destinations from India category
  const popularDestinations = categories.India.slice(0, 6);
  // Get first 6 destinations from International category
  const internationalDestinations = categories.International.slice(0, 6);

  return (
    <footer className="bg-dark text-white pt-5 pb-3 text-start">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12 mb-4 text-start">
            <img 
              src="/assets/images/syw-logo.png" 
              alt="Swayourway Tours Logo" 
              className="mb-3" 
              style={{ maxWidth: '150px' }} 
            />
            {/* <h5 className="text-uppercase mb-3 mb-md-4">Swayourway Tours</h5> */}
            <p className="small">
              We are a team of travel enthusiasts who are dedicated to providing the best travel experiences in India and beyond. 
              Our mission is to make travel accessible, fun, and memorable for everyone.
            </p>
            <div className="social-icons mt-3 mt-md-4">
              <a href="/" className="me-3 text-white">
                <i className="fab fa-facebook-f fa-lg"></i>
              </a>
              <a href="/" className="me-3 text-white">
                <i className="fab fa-instagram fa-lg"></i>
              </a>
              <a href="/" className="me-3 text-white">
                <i className="fab fa-twitter fa-lg"></i>
              </a>
              <a href="/" className="me-3 text-white">
                <i className="fab fa-youtube fa-lg"></i>
              </a>
            </div>
          </div>
          
          <div className="col-lg-2 col-md-6 col-6 mb-4 text-start">
            <h5 className="text-uppercase mb-3 mb-md-4">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/about" className="text-white text-decoration-none" onClick={scrollToTop}>About Us</Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-white text-decoration-none" onClick={scrollToTop}>Contact Us</Link>
              </li>
              <li className="mb-2">
                <Link to="/terms" className="text-white text-decoration-none" onClick={scrollToTop}>Terms & Conditions</Link>
              </li>
              <li className="mb-2">
                <Link to="/privacy" className="text-white text-decoration-none" onClick={scrollToTop}>Privacy Policy</Link>
              </li>
              <li className="mb-2">
                <Link to="/cancellation" className="text-white text-decoration-none" onClick={scrollToTop}>Cancellation Policy</Link>
              </li>
              <li className="mb-2">
                <Link to="/enquiry" className="text-white text-decoration-none" onClick={scrollToTop}>Make an Enquiry</Link>
              </li>
            </ul>
          </div>
          
          <div className="col-lg-2 col-md-6 col-6 mb-4 text-start">
            <h5 className="text-uppercase mb-3 mb-md-4">Popular Destinations</h5>
            <ul className="list-unstyled">
              {popularDestinations.map((dest, idx) => (
                <li className="mb-2" key={dest.name}>
                  <Link
                    to={`/destinations?location=${encodeURIComponent(dest.name)}`}
                    className="text-white text-decoration-none"
                    onClick={scrollToTop}
                  >
                    {dest.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-lg-2 col-md-6 col-6 mb-4 text-start">
            <h5 className="text-uppercase mb-3 mb-md-4">International Destinations</h5>
            <ul className="list-unstyled">
              {internationalDestinations.map((dest, idx) => (
                <li className="mb-2" key={dest.name}>
                  <Link
                    to={`/destinations?location=${encodeURIComponent(dest.name)}`}
                    className="text-white text-decoration-none"
                    onClick={scrollToTop}
                  >
                    {dest.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="col-lg-2 col-md-6 col-sm-12 mb-4 text-start">
            <h5 className="text-uppercase mb-3 mb-md-4">Contact Us</h5>
            <p className="small">
              <i className="fas fa-map-marker-alt me-2"></i> 1 Street, Mumbai, 400000
            </p>
            <p className="small">
              <i className="fas fa-phone me-2"></i>
              <a href="tel:+919220424206" className="text-white text-decoration-none">
                +91 92204 24206
              </a>
            </p>
            <p className="small">
              <i className="fas fa-envelope me-2"></i> infoswayourway@gmail.com 
            </p>
          </div>
        </div>
        
        <hr className="my-3 my-md-4" />
        
      </div>
    </footer>
  );
}

export default Footer;